var _effectorFileName = "/builds/gmini/front-ui-kit/src/Typography/Typography.tsx";
import { TypographyWrapper } from './Typography.styled';
import { jsx as _jsx } from "react/jsx-runtime";

const getHTMLElementType = variant => {
  switch (variant) {
    case 'body1':
    case 'body2':
      return 'p';

    case 'button':
    case 'caption':
    case 'inherit':
    case 'overline':
      return 'span';

    case 'h6':
    case 'subtitle1':
    case 'subtitle2':
      return 'h6';

    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
      return variant;
  }
};

export const Typography = ({
  variant = 'body1',
  noWrap = false,
  align = 'inherit',
  component = 'p',
  ...props
}) => /*#__PURE__*/_jsx(TypographyWrapper, {
  as: component ? component : getHTMLElementType(variant),
  variant: variant,
  noWrap: noWrap,
  align: align,
  ...props,
  children: props.children
});